// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Semantic colors are AA-verified against white text when used as fills:
// primary #0f766e (5.5:1), error #b91c1c (6.3:1), success #15803d (5.1:1),
// warning #b45309 (4.8:1), info #2563eb (4.5:1). The brighter brand teal
// #0d9488 lives in `accent` for borders/icons (3:1 UI minimum only).
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0f766e',
          secondary: '#1a2332',
          accent: '#0d9488',
          error: '#b91c1c',
          info: '#2563eb',
          success: '#15803d',
          warning: '#b45309',
          background: '#f5f6fa',
          surface: '#ffffff',
        },
      },
      dark: {
        colors: {
          primary: '#14b8a6',
          secondary: '#1a2332',
          accent: '#2dd4bf',
          error: '#f87171',
          info: '#60a5fa',
          success: '#4ade80',
          warning: '#fbbf24',
        },
      },
    },
  },
  // One shape language everywhere: lg radius, outlined fields,
  // comfortable density. Explicit per-component props still win.
  defaults: {
    VBtn: { rounded: 'lg' },
    VCard: { rounded: 'lg' },
    VTextField: { variant: 'outlined', density: 'comfortable' },
    VSelect: { variant: 'outlined', density: 'comfortable' },
    VTextarea: { variant: 'outlined', density: 'comfortable' },
    VAutocomplete: { variant: 'outlined', density: 'comfortable' },
    VCombobox: { variant: 'outlined', density: 'comfortable' },
    VAlert: { rounded: 'lg' },
    VChip: { rounded: 'pill' },
  },
  icons: {
    defaultSet: 'mdi',
  },
})

export default vuetify
